import { AccountingMovementsForm } from "../../components";

const AccountingMovementsEdit = () => {
  return <AccountingMovementsForm />;
};

export default AccountingMovementsEdit;
